
  import { Component, Prop, Vue } from 'vue-property-decorator'
  import { QBtn, QCard, QCardSection } from 'quasar'

  @Component({
    components: {
      QBtn, QCard, QCardSection
    }
  })
  export default class Result extends Vue {
    @Prop()
    resultText: string

    expanded = false

    created() {
      this.expanded = !(this.$q.screen.sm || this.$q.screen.xs)
    }

    get labelText() {
      return this.expanded ? 'Lees minder' : 'Lees meer'
    }
  }
